import Axios from "@/plugins/Axios";

export class DocumentosPlanosService {
  async listarPaginado(page = 1, search = "") {
    const response = await Axios().get("planos-bimestrais/documentos-planos", {
      params: { page, search },
    });
    return response.data;
  }

  async salvar(dados) {
    const response = await Axios().post("planos-bimestrais/documentos-planos", dados);
    return response.data;
  }

  async atualizar(id, dados) {
    dados.append("_method", "PUT");
    const response = await Axios().post(`planos-bimestrais/documentos-planos/${id}`, dados);
    return response.data;
  }

  async buscarPorId(id) {
    const response = await Axios().get(`planos-bimestrais/documentos-planos/${id}`);
    return response.data;
  }

  async deletar(id) {
    const response = await Axios().delete(`planos-bimestrais/documentos-planos/${id}`);
    return response.data;
  }

  async restaurar(id) {
    const response = await Axios().post(`planos-bimestrais/documentos-planos/${id}/restore`);
    return response.data;
  }

  async baixarPdf(documentoId) {
    const response = await Axios()
      .get(`planos-bimestrais/documentos-planos/${documentoId}/download`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `documento_planos${documentoId}.pdf`;
        link.click();
      });
    return response;
  }
}

export default new DocumentosPlanosService();
